import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { FiHome, FiList, FiCheckSquare, FiBarChart2 } from 'react-icons/fi';
import { Toaster } from 'react-hot-toast';

// Layout components
import BaseLayout from './shared/ui/layout/BaseLayout';
import MainNav from './shared/ui/navigation/MainNav';
import PublicLayout from './shared/ui/layout/PublicLayout';

// Page components
import Dashboard from './features/dashboard/components/Dashboard';
import TaskList from './features/tasks/components/TaskList';
import TaskForm from './features/tasks/components/TaskForm';
import TaskDetail from './features/tasks/components/TaskDetail';
import TestList from './features/tests/components/TestList';
import TestForm from './features/tests/components/TestForm';
import TestDetail from './features/tests/components/TestDetail';
import EvaluationForm from './features/evaluations/components/EvaluationForm';
import ResultsPage from './features/results/components/ResultsPage'; // Import nowej strony
import EvaluationList from './features/evaluations/components/EvaluationList';
import EvaluationDetail from './features/evaluations/components/EvaluationDetail';
import LoginPage from './features/auth/components/LoginPage';
import AdminRoute from './features/auth/components/AdminRoute';
import RedirectIfAuth from './features/auth/components/RedirectIfAuth';
import ProtectedRoute from './features/auth/components/ProtectedRoute'; // Import ProtectedRoute
import UserEvaluationDetail from './features/results/components/UserEvaluationDetail'; // Import UserEvaluationDetail

// Styles
import './App.css';
import './styles/variables.css';

const navigationItems = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    icon: <FiHome />
  },
  {
    label: 'Tasks',
    path: '/tasks',
    icon: <FiList />
  },
  {
    label: 'Tests',
    path: '/tests',
    icon: <FiCheckSquare />
  },
  {
    label: 'Evaluations',
    path: '/evaluations',
    icon: <FiBarChart2 />
  }
];

const AppContent = () => {
  return (
    <BaseLayout navigation={<MainNav items={navigationItems} />}>
      <Routes>
        <Route element={<AdminRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/tasks" element={<TaskList />} />
          <Route path="/tasks/new" element={<TaskForm />} />
          <Route path="/tasks/:id" element={<TaskDetail />} />
          <Route path="/tasks/:id/edit" element={<TaskForm />} />
          <Route path="/tests" element={<TestList />} />
          <Route path="/tests/new" element={<TestForm />} />
          <Route path="/tests/:id" element={<TestDetail />} />
          <Route path="/tests/:id/edit" element={<TestForm />} />
          <Route path="/evaluations" element={<EvaluationList />} />
          <Route path="/evaluations/:id" element={<EvaluationDetail />} />
          <Route path="/tests/:testId/evaluate" element={<EvaluationForm />} />
          <Route path="/tests/:testId/evaluate/:evaluationId" element={<EvaluationForm />} />
        </Route>
      </Routes>
    </BaseLayout>
  );
};

function App() {
  return (
    <Router>
      <Toaster />
      <Routes>
        <Route path="/login" element={<RedirectIfAuth><PublicLayout><LoginPage /></PublicLayout></RedirectIfAuth>} />
        <Route path="/" element={<ResultsPage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/results/test/:id" element={<ResultsPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/results/evaluation/:id" element={<UserEvaluationDetail />} />
        </Route>
        <Route path="/*" element={<AppContent />} />
      </Routes>
    </Router>
  );
}

export default App; 